import React from 'react'
import HttpServices from '../../utils/Http.services'
import { checkTextTranslation, getObject, imageAddress, pathMaker, translate } from '../../utils/useful'
import TLink from '../TLink'
import FixedView from '../FixedView'

class TabelGlobalUserInput extends React.Component {
    state = {
        data: {}
    }

    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data != this.props.data || prevProps.fullData != this.props.fullData) {
            this.init()
        }
    }

    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value, this.props.extra)
        }
    }

    init = () => {
        // console.log('*initfirst ', getObject(this.props.fullData, 'populates.users'))
        // console.log('*fulldata', this.props.fullData)

        if (this.props.data) {
            let data = {}
            let usersInfo = getObject(this.props.fullData, 'populates.users')
            // console.log('usersInfo', usersInfo)
            if (usersInfo && Array.isArray(usersInfo)) {
                usersInfo.map((element) => {
                    if (element._id == this.props.data) {
                        data = element
                    }

                })
            }
            // console.log('datawiqoiew',data)
            // this.props.data.map((element) => {
            //     console.log('elements',element,id)
            // })
            this.setState({ data })

            // this.fetchUser()


        }
    }
    fetchUser = () => {
        let address = "getOneUserLimitedInfo"
        // console.log('fetchUSER getOneUserLimitedInfo')
        HttpServices.request(address, { id: this.props.data }, (fetchResult, fetchError) => {
            // console.log(fetchResult)
            // console.log(fetchError)

            if (fetchResult?.info) {
                this.setState({ data: fetchResult.info })
            }
        })
    }



    oneUserView(data, fullInfo) {
        return (
            <div  className="w-100 h-100 flexc py-1" style={{ overflow: 'hidden' }}>
                <div className="flexcc">
                    <img src={imageAddress(data?.image, 'profile', 'small')} width={26} height={26} style={{ border: '1px solid #eee', borderRadius: 50, objectFit: 'cover' }} alt='' />
                </div>
                <div className="mld-2 flex-1 " style={{ display: 'inline-block' ,minWidth:0}}>
                    {data?.username && (
                        <div className='w-100'>
                            <p className="font-size-13 w-100" style={{ width: '80%', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{data?.fullname}</p>
                            {fullInfo && (
                                <p className="font-size-12 w-100" style={{ width: '80%', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', color: '#789' }}>@{data?.username}</p>
                            )}
                        </div>
                    )}
                    {(!data?.username && this.props.fullData) && (
                        <div className='w-100'>
                            <p className="font-size-13 w-100" style={{  whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{data?.fullname}</p>
                            {fullInfo && (
                                <p className="font-size-12 w-100" style={{ width: '80%', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', color: '#789' }}>{translate("Virtual User")}</p>
                            )}
                        </div>
                    )}


                </div>
            </div>
        )
    }



    render() {
        let data = typeof this.props.data == 'object' ? this.props.data : this.state.data

        if (data && Object.values(data).length != 0) {
            return (
                <div className='w-100 mycockokc'>
                    <div className='w-100 cursor-pointer' ref={el => this.currentNode = el} onClick={() => { if (!this.props.demo) { this.fixedView.showView() } }}>
                        {this.oneUserView(data)}
                    </div>


                    <FixedView ref={el => this.fixedView = el} nodeRef={this.currentNode} onHide={() => { }} topOffset={0} xOffset={-15} zIndex={15} width={200} >
                        <div className='br-6 px-2 py-1' style={{ backgroundColor: '#fff', boxShadow: '0px 0px 15px #10101020' }}>
                            {this.oneUserView(data, true)}
                        </div>
                    </FixedView>


                </div>
            )
        } else {
            // console.log('firstits',false)
            return (
                <div></div>
            )
        }
    }
}

export default (TabelGlobalUserInput);